
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.398 5.531h14.805l.883-1.093-.898-1.11H.398V2.29h13.993L13.14.797l.507-.43 3.82 3.82v.5l-3.82 3.82-.507-.429 1.257-1.508h-14V5.531z","fill":"currentColor"}})])
          )
        }
      }
    